import $ from 'jquery';
import { Component } from '../core/component';

export class LoadMore extends Component {
    constructor() {
        super();
        this.selector = '[data-loadmore]';
    }

    init() {

        /* Our "Load More" buttons should always have a container specified via the data-loadmore attribute */
        const loadButtons = document.querySelectorAll(this.selector);

        /* The click Event */
        const handleClick = (button, container) => {

            button.setAttribute('disabled', '');
            let isLoading = true;
            let slug = container.getAttribute('data-loadmore-slug');
            let currentPage = parseInt(container.getAttribute('data-loadmore-page'));
            let nextPage = ++currentPage;
            let totalPages = parseInt(container.getAttribute('data-loadmore-total-pages'));
            let pageTrigger = container.getAttribute('data-loadmore-page-trigger');
            let ajaxUrl = `/ajax/${slug}/${pageTrigger}${nextPage}`;
        
            if(isLoading && nextPage <= totalPages) {
                $.ajax(ajaxUrl, {
                    dataType: 'html',
                    success: function (response) {
                        /* Add the next page to the DOM */
                        $(container).append(response);
                        /* Update the page for the next load */
                        container.setAttribute('data-loadmore-page', nextPage);
                        /* Remove the button if no more pages */
                        if(nextPage == totalPages) {
                            $(button).remove();
                        }
                        isLoading = false;
                        button.removeAttribute('disabled');
                    },
                    error: function() {
                        $(button).remove();
                    }
                });
            }
        }
    
        /* Add the event to each button with a matching container */
        loadButtons.forEach((button) => {
            const containerName = button.getAttribute('data-loadmore');
            const container = document.querySelector(`[data-loadmore-name="${containerName}"]`);
            if (container) {
                button.addEventListener('click', () => { handleClick(button, container) });
            }
        });

    }

}


// fetch(ajaxUrl)
//     .then(function(response){
//         return response.text();
//     })
//     .then(function(html){
//         let parser = new DOMParser();
//         let dom = parser.parseFromString(html, "text/html");
//         container.append(dom.body.innerHTML);
//         console.log(dom);
//     });
